import script from "./GroupRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupRow.vue?vue&type=script&setup=true&lang=ts"

import "./GroupRow.vue?vue&type=style&index=0&id=77d3fb90&lang=scss"

const __exports__ = script;

export default __exports__